import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/passingrent.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class ReleasingSpreadWidgetDeveloper extends React.Component {
  static contextType = FilterContext;

  state = {
    effectiveRent: "",
    filters: "",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_developer_effective_rent",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({
          effectiveRent: res.data.effective_rent,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_developer_effective_rent",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            effectiveRent: res.data.effective_rent,
          });
        });
    }
  }

  render() {
    return (
      <div className="newWidgetClass">
        <img
          alt="Effective Rent Icon"
          src="/edge/images/updated_logos/passingrent.svg"
          className="imgWidth100"
        />
        <div className="colorBlue">
          <h2>{this.state.effectiveRent}</h2>
          <p>Effective Rent</p>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ReleasingSpreadWidgetDeveloper);
